import LabelValue from '../search/result/label-value';
import PropTypes from 'prop-types';
import React from 'react';

const Represented = ({listing, filter}) => {
  const getSideTypeInfo = () => {
    let represented;
    if (listing.agentSideType && listing.agentSideType.length > 0) {
      if(Array.isArray(filter.agentId)){
        represented = [];
        filter.agentId.forEach( (id) => {
          listing.agentSideType.forEach( (sideType, index) => {
            if (sideType.identifier === id) {
              represented.push(sideType.represented);
            }
          });
        });
        if (represented.indexOf('Both') !== -1 || (represented.indexOf('Buyer') !== -1 && represented.indexOf('Seller') !== -1)) {
          represented = 'Seller & Buyer';
        } else if (represented.indexOf('Buyer') !== -1) {
          represented = 'Buyer';
        } else if (represented.indexOf('Seller') !== -1) {
          represented = 'Seller';
        } else {
          represented = null;
        }
      } else {
        listing.agentSideType.forEach( (sideType, index) => {
          if (sideType.identifier === filter.agentId) {
            represented = sideType.represented;
          }
        });
      }
    }
    return represented;
  }
  
  const represented = getSideTypeInfo();
  return represented ? (
    <ul>
      <LabelValue label="Represented" value={represented}/>
    </ul>
  ) : null;
};

Represented.propTypes = {
  filter: PropTypes.object.isRequired,
  listing: PropTypes.object.isRequired
};

export default Represented;


// WEBPACK FOOTER //
// ./src/components/solds/represented.js